import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Domain } from '../../../store/entities/models/domain.model';

@Component({
  selector: 'app-domain-selector',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './domain-selector.component.html',
  styleUrl: './domain-selector.component.css',
})

export class DomainSelectorComponent {
  @Input() domains: readonly Domain[] = [];
  @Input() selectedDomainId: string | null = null;
  @Input() disabled = false;

  @Output() domainChange = new EventEmitter<string>();

  get sortedDomains(): Domain[] {
    return [...this.domains].sort((left, right) => left.name.localeCompare(right.name));
  }

  onDomainChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const selectedDomainId = selectElement.value;

    if (selectedDomainId) {
      this.domainChange.emit(selectedDomainId);
    }
  }
}

